/**
 * Function that returns a modal from the global modals array
 * Is used to retrieve modal state
 * @param {ref} modal - Store ref to modals
 * @param {string} id - Id of the required modal
 * @returns {Modal} - Matching modal
 */
export function getModalById(modal, id) {
    return modal.find((m) => m.id === id)
}
